import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    addCadreRequest: ['response'],
    addCadreSuccess: ['response', 'loading'],
    addCadreFailure: ['error'],
})

export const addCadreTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    success: null,
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const addCadreRequest = state => state.merge({ loading: true })

const addCadreSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
        loading: false,
    })

const addCadreFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        loading: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.ADD_CADRE_REQUEST]: addCadreRequest,
    [Types.ADD_CADRE_SUCCESS]: addCadreSuccess,
    [Types.ADD_CADRE_FAILURE]: addCadreFailure,
})
